import axios from "axios";
import axiosInstance from "../axiosInstance";
import config from "../../config";

export const distinctValuesService = {
  fetchClientColumns: async (field) => {
    try {
      let obj = {
        service: "client",
        field,
      };
      let response = await axiosInstance.post("/distinct-values", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchColumnValues: async (
    service,
    field,
    search,
    client,
    limit = 15,
    skip = 0,
  ) => {
    try {
      let obj = {
        service,
        field,
        search,
        client,
        limit,
        skip,
      };
      let response = await axiosInstance.post("/distinct-values", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
